module.exports = __webpack_public_path__ + "static/media/om_hairstyle_combover_front_vector.72a232f8.svg";